import createReducer from '../utils/createReducer';
import actions from '../actions/payoutDetails';
import {checkPayoutDetailsBtnStatus} from '../utils/validate';

const initialState = {};

const actionHandlers = {
    [actions.HANDLE_PAYOUT_DETAILS_FIELD_VALUE_CHANGE](state, {payload}) {
        const bankingCountryList = state.bankingCountryList;

        switch (payload.fieldName) {

            case 'bankingCountry': {
                const bankingCountryCode = payload.fieldValue;
                const bankingCountry = (bankingCountryList instanceof Array) ? bankingCountryList.find((e) => e.countryCode === bankingCountryCode) : null;

                return {
                    ...state,
                    bankingCountryCode,
                    bankingCountry,
                    showBankingState: !!bankingCountry?.states,
                    bankingState: ''
                };
            }

            case 'bankingState': return {
                ...state,
                bankingState: payload.fieldValue
            }

            default: return {
                ...state
            };
        }
    },

    [actions.PAYOUT_DETAILS_FIELD_ERROR](state, {payload}) {
        switch (payload.fieldName) {

            case 'bankingCountry': return {
                ...state,
                bankingCountryCodeError: payload.msg
            };

            case 'bankingState': return {
                ...state,
                bankingStateError: payload.msg
            }

            default: return {
                ...state
            };
        }
    },

    [actions.TOGGLE_PAYOUT_DETAILS_CONTINUE_BUTTON](state, {payload}) {
        const enableContinueButton = checkPayoutDetailsBtnStatus(state, payload.currency);
        return {
            ...state,
            enableContinueButton
        };
    },

    [actions.PAYOUT_DETAILS_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.DISMISS_ALERT_BOX](state) {
        return {
            ...state,
            serviceError: ''
        };
    },

    [actions.GET_PAYOUT_METADATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            bankingCountryList: payload.bankingCountryList,
            userInfo: payload.userInfo,
            countryList: payload.countryList,
        };
    },

    [actions.SET_UNSUPPORTED_PAYOUT_COUNTRY](state, {payload}) {
        return {
            ...state,
            unsupportedPayoutCountryName: payload.countryName
        };
    },
};

export default createReducer(actionHandlers, initialState);
